import React, { useEffect, useState } from "react"
import { useSelector, useDispatch } from "react-redux"
import { Row, Col } from "react-bootstrap"

import { IDLE, PENDING, LIST, EDIT } from "const"
import {
    hasProjectAccess,
    StateType,
} from "client/utils"
import {
    PRM_PERMISSIONS,
    StoreType,

    LoadProjectPermissions,
    LoadAccountGroups,
    LoadProjectGroups,
    SaveProjectPermissions,

    setProjectPermissions,
    setGroupList,
    setProjectGroupList,
    setProjectPermissionsReloadList,
} from "client/store"
import {
    Container,
    PageHeader,
    PageTitle,
    PageContent,
    Loader,
    PageForm,
    Button,
    SpinnerIcon,
} from "client/components"

import AccessDenied from "client/parts/accessDenied"
import Permissions from "./permissions"

let isMounted: boolean

const ProjectPermissions = () => {
    const project = useSelector((state: StoreType) => state.project.projectView)
    const projectPermissions = useSelector((state: StoreType) => state.projectPermissions.projectPermissions)
    const reloadList = useSelector((state: StoreType) => state.projectPermissions.reloadList)

    const lang = useSelector((state: StoreType) => state.system.lang)
    const dispatch = useDispatch()

    const [loadState, setLoadState] = useState<StateType>(IDLE)
    const [applyState, setApplyState] = useState<StateType>(IDLE)

    useEffect(() => {
        isMounted = true
        return () => {
            isMounted = false
        }
    }, [])

    useEffect(() => {
        if (!reloadList || !project) return
        setLoadState(PENDING)
        Promise.all([
            LoadProjectPermissions(project.accountId, project.id, lang).then((res) => {
                dispatch(setProjectPermissions(res.permissionsSectioned))
            }),
            LoadAccountGroups(project.accountId).then((res) => {
                dispatch(setGroupList(res))
            }),
            LoadProjectGroups(project.accountId, project.id, true).then((res) => { // groups are imported after project is created
                dispatch(setProjectGroupList(res))
            }),
        ]).then(() => {
            setLoadState(IDLE)
        })
    }, [reloadList, project])

    const onCancel = () => {
        dispatch(setProjectPermissionsReloadList(false))
        setTimeout(() => {
            dispatch(setProjectPermissionsReloadList(true))
        }, 0)
    }

    const onApply = () => {
        setApplyState(PENDING)
        SaveProjectPermissions(project.id, projectPermissions)
        .then(() => {
            if (isMounted) setApplyState(IDLE)
        })
    }

    const listAccess = hasProjectAccess(PRM_PERMISSIONS, LIST)
    const editAccess = hasProjectAccess(PRM_PERMISSIONS, EDIT)

    if (!listAccess) return <AccessDenied />
    return (
        <Container>
            <PageHeader>
                <PageTitle>{lang.permissions}</PageTitle>
            </PageHeader>
            <PageContent>
                {loadState === PENDING && <Loader />}
                <Permissions />
                {
                    editAccess && (
                        <PageForm>
                            <Row>
                                <Col xs={12}>
                                    <Button variant="success" row onClick={() => onApply()}>
                                        {applyState === PENDING ? <SpinnerIcon /> : lang.apply}
                                    </Button>
                                    <Button row onClick={onCancel}>{lang.cancel}</Button>
                                </Col>
                            </Row>
                        </PageForm>
                    )
                }
            </PageContent>
        </Container>
    )
}
export default ProjectPermissions
